import React, { Component } from "react";
import axiosInstance from "../../api/utils/axiosInstance";
import moment from "moment";
import { toast } from "react-toastify";
import {
  SolutionOutlined,
  FilterOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { Steps, Button } from "antd";
import { Row, Col } from "react-bootstrap";
import VrstaIzvjestajaOptions from "../../components/Izvjestaj/VrstaIzvjestajaOptions";
import FilterIzvjestaja from "../../components/Izvjestaj/FilterIzvjestaja";
import PrikazIzvjestaja from "../../components/Izvjestaj/PrikazIzvjestaja";

export default class Izvjestaj extends Component {
  state = {
    izvjestajParams: {
      datOd: null,
      datDo: null,
      formatIzvjestaja: "",
      vrstaIzvjestaja: null,
      filter: null,
    },
    vrsteIzvjestaja: [],
    dropdownFilterData: [],
    dropdownLabel: "",
    steps: {
      current: 0,
    },
    izvjestajType: null,
    izvjestajTitle: "",
    izvjestajHeaders: [],
    izvjestajDataList: [],
    izvjestajData: [],
    datePickerError: false
  };

  componentDidMount = () => {
    this.getVrsteIzvjestaja();
  };

  next = () => {
    this.setState(
      (prevState) => ({
        steps: {
          ...prevState.steps,
          current: prevState.steps.current + 1,
        },
      }),
      () => {
        if (this.state.steps.current == 1) {
          this.getDropdownData();
        } else if (this.state.steps.current == 2) {
          this.getIzvjestaj();
        }
      }
    );
  };

  prev = () => {
    this.setState((prevState) => ({
      steps: {
        ...prevState.steps,
        current: prevState.steps.current - 1,
      },
    }));

    if (this.state.steps.current == 1) {
      this.setState({
        izvjestajParams: {
          datOd: null,
          datDo: null,
          formatIzvjestaja: "",
          filter: null,
        },
      });
    }
  };

  // ŠIFRARNICI
  getVrsteIzvjestaja = async () => {
    await axiosInstance.get("/sifarnici/vrsteIzvjestaja").then((res) => {
      this.setState({
        vrsteIzvjestaja: res.data,
      });
    });
  };

  getDropdownData = () => {
    const izvjestajParams = this.state.izvjestajParams;

    if (izvjestajParams.vrstaIzvjestaja == 1) {
      this.getVrsteZahtjeva();
    } else if (izvjestajParams.vrstaIzvjestaja == 2) {
      this.getVrsteStatusa();
    } else if (
      izvjestajParams.vrstaIzvjestaja == 3 ||
      izvjestajParams.vrstaIzvjestaja == 5
    ) {
      this.getVrsteSubjekata();
    } else if (izvjestajParams.vrstaIzvjestaja == 4) {
      this.getVrsteMjera();
    }
  };

  getVrsteZahtjeva = async () => {
    await axiosInstance.get("/sifarnici/vrsteZahtjeva").then((res) => {
      this.setState({
        dropdownFilterData: res.data,
        dropdownLabel: "Filtriraj prema vrsti zahtjeva",
      });
    });
  };

  getVrsteStatusa = async () => {
    await axiosInstance.get("/sifarnici/vrsteStatusa").then((res) => {
      this.setState({
        dropdownFilterData: res.data,
        dropdownLabel: "Filtriraj po statusu zahtjeva",
      });
    });
  };

  getVrsteSubjekata = async () => {
    await axiosInstance.get("/sifarnici/vrsteSubjekata").then((res) => {
      this.setState({
        dropdownFilterData: res.data,
        dropdownLabel: "Filtriraj prema vrsti subjekta",
      });
    });
  };

  getVrsteMjera = async () => {
    await axiosInstance.get("/sifarnici/vrsteMjera").then((res) => {
      this.setState({
        dropdownFilterData: res.data,
        dropdownLabel: "Filtriraj prema vrsti mjere",
      });
    });
  };

  getIzvjestaj = async () => {
    const izvjestajParams = this.state.izvjestajParams;

    try {
      await axiosInstance.post("/izvjestaji", izvjestajParams).then((res) => {
        this.setState(
          {
            izvjestajType: res.data.type,
            izvjestajTitle: res.data.title,
            izvjestajHeaders: res.data.headers,
            izvjestajDataList: res.data.dataList,
          },
          () => {
            this.remapIzvjestajData();
          }
        );
      });
    } catch (datePickerError) {
      throw datePickerError;
    }
  };

  remapIzvjestajData = () => {
    const { izvjestajType, izvjestajDataList } = this.state;

    let data = [];

    if (izvjestajType == 1) {
      izvjestajDataList.map((element, index) => {
        data.push({
          key: index,
          1: index + 1 + ".",
          2: this.capitalize(element.formDescription),
          3: element.nazivSubjekta,
          4: element.oib,
          5: element.klasa ? element.klasa : "",
          6: moment(element.datZaprimanja).format("DD.MM.YYYY")
        });
      });
    } else if (izvjestajType == 2) {
      izvjestajDataList.map((element, index) => {
        data.push({
          key: index,
          1: index + 1 + ".",
          2: element.nazivSubjekta,
          3: element.oib,
          4: element.klasa,
          5: element.vrstaOdluke,
          6: element.datumOdluke
        });
      });
    } else if (izvjestajType == 3) {
      izvjestajDataList.map((element, index) => {
        data.push({
          key: index,
          1: index + 1 + ".",
          2: element.vrstaSubjekta,
          3: element.naziv,
          4: element.oib,
          5: element.regBroj,
          6: element.datUpisa,
          7: element.klasa ? element.klasa : " - "  + ", " + element.urBroj ? element.urBroj :  " - " ,
        });
      });
    } else if (izvjestajType == 4) {
      izvjestajDataList.map((element, index) => {
        data.push({
          key: index,
          1: index + 1 + ".",
          2: element.vrstaSubjekta,
          3: element.naziv,
          4: element.oib,
          5: element.regBroj,
          6: element.opisMjere,
          7: element.brRjesenja,
        });
      });
    } else if (izvjestajType == 5) {
        izvjestajDataList.map((element, index) => {
          data.push({
            key: index,
            1: index + 1 + ".",
            2: element.vrstaSubjekta,
            3: element.naziv,
            4: element.oib,
            5: element.regBroj,
            6: element.tstamp,
            7: element.klasa ? element.klasa : " - "  + ", " + element.urBroj ? element.urBroj :  " - " ,
          });
        });
      }

    if (data) {
      this.setState({
        izvjestajData: data,
      });
    }
  };

  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  };

  printIzvjestajXlsx = (e) => {
    e.persist();

    this.setState(
      (prevState) => ({
        izvjestajParams: {
          ...prevState.izvjestajParams,
          formatIzvjestaja: "xls",
        },
      }),
      () => {
        this.printIzvjestaj(e);
      }
    );
  };

  printIzvjestajPdf = (e) => {
    e.persist();

    this.setState(
      (prevState) => ({
        izvjestajParams: {
          ...prevState.izvjestajParams,
          formatIzvjestaja: "pdf",
        },
      }),
      () => {
        this.printIzvjestaj(e);
      }
    );
  };

  printIzvjestaj = async (e) => {
    e.preventDefault();

    const izvjestajParams = this.state.izvjestajParams;

    await axiosInstance
      .post("/izvjestaji/print", izvjestajParams)
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([this.b64toBlob(res.data.document)])
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", res.data.name);
        document.body.appendChild(link);
        link.click();
      });
  };

  b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });

    return blob;
  };

  // HANDLERI
  dropdownVrIzvjHandler = (e) => {
    e.persist();

    const targetValue = e.target.value;

    this.setState((prevState) => ({
      izvjestajParams: {
        ...prevState.izvjestajParams,
        vrstaIzvjestaja: targetValue,
      },
    }));
  };

  dropdownFilterHandler = (e) => {
    e.persist();
    const targetValue = e.target.value;

    this.setState((prevState) => ({
      izvjestajParams: {
        ...prevState.izvjestajParams,
        filter: targetValue,
      },
    }));
  };

  dropdownFilterHandler2 = (e) => {
    e.persist();
    const targetValue = e.target.value;

    this.setState((prevState) => ({
      izvjestajParams: {
        ...prevState.izvjestajParams,
        filter: targetValue,
      },
    }), () => {
        this.getIzvjestaj();
    });
  };

  datePickerHandler = (date, dateString, objData) => {
    const selectedDate = dateString;

    this.setState((prevState) => ({
        izvjestajParams: {
          ...prevState.izvjestajParams,
          [objData.id]: selectedDate,
        },
      }), () => {
        if(this.state.izvjestajParams.datDo && (moment(this.state.izvjestajParams.datOd, "DD.MM.YYYY").format("YYYY-MM-DD") > moment(this.state.izvjestajParams.datDo, "DD.MM.YYYY").format("YYYY-MM-DD"))) {
            this.setState({
                datePickerError: true
            }, () => {
                toast.info("Datum od ne može biti veći od datuma do!", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
        } else {
            this.setState({
                datePickerError: false
            });
        }
      });




  };

  render() {
    const steps = [
      {
        key: 1,
        title: "Vrsta izvještaja",
        content: "First-content",
        icon: <SolutionOutlined />,
      },
      {
        key: 2,
        title: "Filter izvještaja",
        content: "Second-content",
        icon: <FilterOutlined />,
      },
      {
        key: 3,
        title: "Izvještaj",
        content: "Last-content",
        icon: <BarChartOutlined />,
      },
    ];

    const { Step } = Steps;

    const current = this.state.steps.current;

    return (
      <>
        <div>
          <Row className="row justify-content-center">
            <Col className="align-self-center">
              <Row>
                <Col xl={8} lg={10} md={12}>
                  <Steps current={current}>
                    {steps.map((item) => (
                      <Step
                        icon={item.icon}
                        key={item.key}
                        title={item.title}
                      />
                    ))}
                  </Steps>
                </Col>
              </Row>

              {current == 0 && (
                <Row>
                  <Col xl={8} lg={10} md={12} className="steps-content">
                    <Row className="row justify-content-center">
                      <Col xl={6} lg={8} md={12} className="align-self-center">
                        <VrstaIzvjestajaOptions
                          {...this.state}
                          dropdownVrIzvjHandler={this.dropdownVrIzvjHandler}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
              {current == 1 && (
                <Row>
                  <Col xl={8} lg={10} md={12} className="steps-content">
                    <Row className="row justify-content-center">
                      <Col xl={6} lg={8} md={12} className="align-self-center">
                        <FilterIzvjestaja
                          {...this.state}
                          datePickerHandler={this.datePickerHandler}
                          dropdownFilterHandler={this.dropdownFilterHandler}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
              {current == 2 && (
                <Row className="fade-in-animation">
                  <Col
                    className="steps-content"
                    style={{ backgroundColor: "transparent", paddingBottom: 0 }}
                  >
                    <Row className="row justify-content-center">
                      <Col className="align-self-center">
                        <PrikazIzvjestaja
                          {...this.state}
                          printIzvjestajXlsx={this.printIzvjestajXlsx}
                          printIzvjestajPdf={this.printIzvjestajPdf}
                          dropdownFilterHandler={this.dropdownFilterHandler2}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              <div className="steps-action invert">
                {current == 0 && (
                  <Row>
                    <Col xl={8} lg={10} md={12}>
                      <Button
                        disabled={!this.state.izvjestajParams.vrstaIzvjestaja}
                        type="primary"
                        onClick={this.next}
                      >
                        Nastavi
                      </Button>
                    </Col>
                  </Row>
                )}
                {current == 1 && (
                  <Row>
                    <Col xl={8} lg={10} md={12}>
                      <Button
                        disabled={
                            this.state.datePickerError ||
                            !this.state.izvjestajParams.datOd ||
                            !this.state.izvjestajParams.datDo 
                        }
                        type="primary"
                        onClick={this.next}
                      >
                        Prikaži izvještaj
                      </Button>

                      <Button
                        style={{ margin: 8 }}
                        onClick={() => this.prev()}
                        className="ant-btn-back"
                      >
                        Povratak
                      </Button>
                    </Col>
                  </Row>
                )}
                {current == 2 && (
                  <>
                    <Button
                      style={{ margin: 8 }}
                      onClick={() => this.prev()}
                      className="ant-btn-back"
                    >
                      Povratak
                    </Button>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}
